module Meevo.Plugins.Services {
    "use strict";
    /**
    * SwapSplitSection Section -- need aggregate model for handling functionality.
    */
    export class SwapSplitSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.ServiceSplitServices> {
        splitServiceDetail: Model.SplitServiceDetail;
        selectedServiceList: any;
        exceptionServicelist: any;
        selfService: any;
        isRedemptionProductUnitEnabled: boolean;
        someServiceHasProductUnitEnabled: boolean;
        productUnitEnumType: any
        splitServicesExclusionList: any;
        public serviceSearchCriteria: any;        
        constructor(sectionId: number, displayNameContentKey: string, template: string, isPrimarySection: boolean,
            handlesOwnCrud: boolean, baseEndpoint: string, sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            private modalService: Components.Modal.IModalService,
            sectionSecurityKey?: string,
            protected trackingService?: Meevo.Components.Tracking.ITrackingService) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);
            this.productUnitEnumType = Model.PackageServiceRedemptionEnum.ProductUnit;
            this.serviceSearchCriteria = {
                view: Model.ServiceSearchView.ExcludeProductUnitRedeemedServices
            } 
        }

        activate(): void {
            super.activate();
            this.selfService = [{ id: this.model.id }];
            this.splitServicesExclusionList = this.model.splitServices.concat(this.model.splitServicesExclusionList.map(s => ({ id: s.id })));
            this.exceptionServicelist = _.union(this.splitServicesExclusionList, this.selfService);
            this.updateModel();
        }
        postUpdate(): void {
            super.postUpdate();
            this.updateModel();
        }
        updateModel() {
            this.isRedemptionProductUnitEnabled = this.model.packageServiceRedemptionEnum == this.productUnitEnumType && this.model.isProductUsageEnabled;
            this.someServiceHasProductUnitEnabled = this.model.splitServices.some(s => s.isProductUsageEnabled && s.packageServiceRedemptionEnum == this.productUnitEnumType);
        }

        addService(): void {
            var model = this.model as Model.ServiceSplitServices;   
            if (!this.model.canAddSplitServices) {
                this.splitServiceDetail = null;
                this.modalService.alert("LABEL_SERVICE_BY_PRODUCT_UNIT_SPLIT_RULE");
                return;
            }

            if (Model.Guard.isSomething(this.model)
                && Model.Guard.isSomething(this.splitServiceDetail)
                && _.all(this.model.splitServices, (ec) => { return ec.id !== this.splitServiceDetail.id })) {
                {
                    this.splitServiceDetail.quantity = 1;
                    this.model.splitServices.push(this.splitServiceDetail);
                    this.splitServiceDetail = undefined;
                }
            }
            this.exceptionServicelist = _.union(this.model.splitServices, this.selfService, this.splitServicesExclusionList);
            this.usageTrackingLog(Meevo.Model.NounEnum.ServiceSplitMerge, Meevo.Model.VerbEnum.AddNewButtonClicked);
        }

        removeService(index: number): void {
            if (Model.Guard.isSomething(this.model)) {
                var removedItem = this.model.splitServices[index];
                this.exceptionServicelist = _.without(this.exceptionServicelist, _.findWhere(this.exceptionServicelist, {
                    id: removedItem.id
                }));
                this.model.splitServices.splice(index, 1);
            }
            this.exceptionServicelist = _.union(this.model.splitServices, this.selfService, this.splitServicesExclusionList);
            this.usageTrackingLog(Meevo.Model.NounEnum.ServiceSplitMerge, Meevo.Model.VerbEnum.DeleteButtonClicked);
        }

        usageTrackingLog(nounEnum: Meevo.Model.NounEnum, verbEnum: Meevo.Model.VerbEnum): void {
            let trackingItem = new Meevo.Model.TrackingItem(nounEnum, verbEnum, null, this.parentItemId);
            this.trackingService.saveTrackingInfo(trackingItem);
        }

    }
}